import React, { SyntheticEvent, useContext, useEffect, useState } from "react";
import { LocalizationContext } from "../../../../../../../../locales/Translation";
import { useDispatch, useSelector } from "react-redux";
import {
  dashboardDeskimoDeskBookingFilterSelector,
  dashboardFilterDateRangeSelector,
  filterListPropertySelectedSelector,
} from "../../../../../../selectors/DashboardSelectors";
import { createDeskBookingStatusFilterService } from "../../../../../../services/DashboardServices";
import {
  PROPERTY,
  ROOM_BOOKING_ALL_STATUS,
  ROOM_BOOKING_CANCELLED_STATUS,
  ROOM_BOOKING_COMPLETED_STATUS,
  ROOM_BOOKING_CONFIRMED_STATUS,
  ROOM_BOOKING_DECLINED_STATUS,
  ROOM_BOOKING_NOT_REFUNDED_STATUS,
  ROOM_BOOKING_PENDING_PAYMENT_STATUS,
  ROOM_BOOKING_PENDING_REFUNDED_STATUS,
  ROOM_BOOKING_PENDING_STATUS,
  ROOM_BOOKING_REFUND_FILTER,
  ROOM_BOOKING_REFUNDED_STATUS,
} from "../../../../../../configs/Constants";
import { dashboardDeskimoDeskBookingFilterAction } from "../../../../../../actions/DashboardActions";
import DropdownWithCheckboxMenu from "../../../../../../../../components/DropdownWithCheckboxMenu";
import { PUBLIC_URL } from "../../../../../../../App/configs/Constants";

const FilterDeskBooking = () => {
  const { translations } = useContext(LocalizationContext);

  const dispatch = useDispatch();
  const dashboardDeskBookingFilter = useSelector(
    dashboardDeskimoDeskBookingFilterSelector
  );
  const dashboardFilterDateRange = useSelector(
    dashboardFilterDateRangeSelector
  );
  const filterListPropertySelected = useSelector(
    filterListPropertySelectedSelector
  );
  const [deskBookingStatus, setDeskBookingStatus] = useState<
    { id: string; name: string }[]
  >([]);

  useEffect(() => {
    (async () => {
      try {
        if (dashboardFilterDateRange === null) {
          return;
        }

        await createDeskBookingStatusFilterService({
          translations,
          setStatus: setDeskBookingStatus,
          type: PROPERTY,
          propertyContext: false,
          deskimoAdmin: true,
        });
      } catch (e) {
        console.log("e", e);
      }
    })();
  }, [
    dashboardDeskBookingFilter?.keyword,
    dashboardFilterDateRange,
    filterListPropertySelected,
  ]);

  const _onChangeFilter = (e: SyntheticEvent, data: any) => {
    if (data.value === ROOM_BOOKING_ALL_STATUS) {
      if (data.checked) {
        dispatch(
          dashboardDeskimoDeskBookingFilterAction({
            key: "status",
            value: [
              ROOM_BOOKING_ALL_STATUS,
              ROOM_BOOKING_CONFIRMED_STATUS,
              ROOM_BOOKING_PENDING_STATUS,
              ROOM_BOOKING_DECLINED_STATUS,
              ROOM_BOOKING_CANCELLED_STATUS,
              ROOM_BOOKING_COMPLETED_STATUS,
              ROOM_BOOKING_PENDING_PAYMENT_STATUS,
            ],
          })
        );
        dispatch(
          dashboardDeskimoDeskBookingFilterAction({
            key: "refund_status",
            value: [
              ROOM_BOOKING_PENDING_REFUNDED_STATUS,
              ROOM_BOOKING_REFUNDED_STATUS,
              ROOM_BOOKING_NOT_REFUNDED_STATUS,
            ],
          })
        );
      } else {
        dispatch(
          dashboardDeskimoDeskBookingFilterAction({
            key: "status",
            value: [],
          })
        );
        dispatch(
          dashboardDeskimoDeskBookingFilterAction({
            key: "refund_status",
            value: [],
          })
        );
      }
      return;
    }

    if (data.checked) {
      if (ROOM_BOOKING_REFUND_FILTER.includes(data.value)) {
        const newValue = [
          ...dashboardDeskBookingFilter.refund_status,
          data.value,
        ];
        dispatch(
          dashboardDeskimoDeskBookingFilterAction({
            key: "refund_status",
            value: newValue,
          })
        );
      } else {
        const newValue = [...dashboardDeskBookingFilter.status, data.value];
        dispatch(
          dashboardDeskimoDeskBookingFilterAction({
            key: "status",
            value: newValue,
          })
        );
      }
      return;
    }

    if (ROOM_BOOKING_REFUND_FILTER.includes(data.value)) {
      const newValue = dashboardDeskBookingFilter.refund_status.filter(
        (status: string) =>
          status !== data.value && status !== ROOM_BOOKING_ALL_STATUS
      );
      dispatch(
        dashboardDeskimoDeskBookingFilterAction({
          key: "refund_status",
          value: newValue,
        })
      );
    } else {
      const newValue = dashboardDeskBookingFilter.status.filter(
        (status: string) =>
          status !== data.value && status !== ROOM_BOOKING_ALL_STATUS
      );
      dispatch(
        dashboardDeskimoDeskBookingFilterAction({
          key: "status",
          value: newValue,
        })
      );
    }
  };

  return (
    <div className={"dropdown-filter"}>
      <DropdownWithCheckboxMenu
        onChange={_onChangeFilter}
        listCheckBox={deskBookingStatus.map((filter: any) => {
          if (ROOM_BOOKING_REFUND_FILTER.includes(filter.id)) {
            if (dashboardDeskBookingFilter.refund_status.includes(filter.id)) {
              filter.checked = true;
            } else {
              filter.checked = false;
            }

            return filter;
          }

          if (dashboardDeskBookingFilter.status.includes(filter.id)) {
            filter.checked = true;
          } else {
            filter.checked = false;
          }

          return filter;
        })}
        label={translations.filters}
        icon={
          <img
            alt={"Deskimo"}
            src={PUBLIC_URL + "/assets/icons/icon-filter.svg"}
          />
        }
      />
    </div>
  );
};

export default FilterDeskBooking;
